const SECRET_FIELD = '(?:access_token|refresh_token|id_token|client_secret|authorization_code|oauth_code|code|token)';

/** Return an error string safe for rendering in the UI. */
export function sanitizeDisplayError(error, fallback = 'Request failed') {
  const message = typeof error === 'string' ? error : error?.message;
  if (typeof message !== 'string' || !message.trim()) return fallback;

  return message
    .replace(new RegExp(`([?&]${SECRET_FIELD}=)[^&#\\s]+`, 'gi'), '$1[redacted]')
    .replace(new RegExp(`(%3[f&]${SECRET_FIELD}%3[d])[^%&\\s]+`, 'gi'), '$1[redacted]')
    .replace(new RegExp(`(\\b${SECRET_FIELD}\\b\\s*[:=]\\s*)(?:"[^"]*"|'[^']*'|[^\\s&,;]+)`, 'gi'), '$1[redacted]')
    .replace(/\b((?:authorization|oauth)\s+code|code)\s+[^\s&,;]+/gi, '$1 [redacted]')
    .replace(/\b((?:(?:access|refresh|id|oauth)\s+)?token)\s+[^\s&,;]+/gi, '$1 [redacted]')
    .replace(/\bBearer\s+[^\s,;]+/gi, 'Bearer [redacted]')
    .replace(/\beyJ[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}\b/g, '[redacted token]');
}
